<template>
  <router-link tag="div" to="/leavemsg" class="liuyan-out flex-center cursor">
    <!-- <p>在线留言</p> -->
  </router-link>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.liuyan-out {
  width: 90px;
  height: 105px;
  position: fixed;
  right: 0;
  top: 70%;
  transform: translateY(-50%);
  z-index: 9;
  background-image: url("../assets/img01/leave_bg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  transition: all .3s;
  // background: linear-gradient(350.38deg, #2becfe -35.71%, #8d3efc 115.42%);
  // border-radius: 6px;

  // p {
  //   width: 20px;
  //   font-size: 17px;
  //   color: #ffffff;
  //   text-align: center;
  // }
}
.liuyan-out:hover {
  background-image: url("../assets/img01/leave_bg_hover.png");
}

@media (min-width: 1280px) {
  // .liuyan-out {
  //   width: 36px;
  //   height: 86px;
  //   background: url("../assets/images/fixed-msg-bg.png") 0 0/100% 100% no-repeat;
  //   position: fixed;
  //   right: 28px;
  //   bottom: 28px;
  //   z-index: 9;
  //   p {
  //     width: 20px;
  //     font-size: 12px;
  //     color: #ffffff;
  //     text-align: center;
  //   }
  // }
}
</style>
